/**
 * 🟦 V11.5 — Marketplace Bridge.
 *
 * Cliente fetch contra /api/recipes/marketplace y /like.
 * Maneja cookies (credentials: include) porque el endpoint requiere auth.
 */
import { BACKEND_URL } from '../../../config/api';
import { importRecipeToStore } from './importRecipe';

const API = `${BACKEND_URL}/api`;

/**
 * GET /api/recipes/marketplace → {recipes, count, mostLoved, trendingWindowDays}
 * Devuelve {ok, recipes[], mostLoved[], error?}.
 */
export async function fetchMarketplaceRecipes() {
  try {
    const res = await fetch(`${API}/recipes/marketplace`, {
      method: 'GET',
      credentials: 'include',
    });
    if (!res.ok) return { ok: false, error: `http_${res.status}`, recipes: [], mostLoved: [] };
    const data = await res.json();
    return {
      ok: true,
      recipes: Array.isArray(data?.recipes) ? data.recipes : [],
      mostLoved: Array.isArray(data?.mostLoved) ? data.mostLoved : [],
    };
  } catch (e) {
    return { ok: false, error: 'network_error', recipes: [], mostLoved: [] };
  }
}

/**
 * POST /api/recipes/marketplace/like/{id} → {ok, likes}
 */
export async function likeMarketplaceRecipe(recipeId) {
  if (!recipeId) return { ok: false, error: 'missing_id' };
  try {
    const res = await fetch(`${API}/recipes/marketplace/like/${encodeURIComponent(recipeId)}`, {
      method: 'POST',
      credentials: 'include',
    });
    if (!res.ok) return { ok: false, error: `http_${res.status}` };
    const data = await res.json();
    return { ok: true, likes: data?.likes ?? 0 };
  } catch {
    return { ok: false, error: 'network_error' };
  }
}

/**
 * Importa una receta del marketplace al store local del usuario.
 * Adapta el shape (steps ya vienen como {instruction, patch}).
 */
export function importMarketplaceRecipe(marketplaceRecipe, appId) {
  if (!marketplaceRecipe || !appId) return { ok: false, error: 'invalid_input' };
  const portable = {
    version: '1.0',
    id: '',
    name: marketplaceRecipe.name,
    description: marketplaceRecipe.description || '',
    nodeType: marketplaceRecipe.nodeType,
    steps: marketplaceRecipe.steps || [],
    createdAt: new Date().toISOString(),
  };
  return importRecipeToStore(portable, appId);
}
